import { POLICY_PAGES, getTenantConfig } from 'Utils';
import Footer from 'Components/Footer';
import ProgressBar from 'Components/ProgressBar';

const DefaultLayout = ({
  children,
  country,
  isUimLoaded,
  language,
  location,
  strings,
}) => {
  const hasFooter = POLICY_PAGES.includes(location.pathname);

  const renderLogo = () => {
    const logo = getTenantConfig().logo;
    return (
      <img alt={logo.alt} className="logo" width={logo.width} src={logo.src} />
    );
  };

  if (!isUimLoaded) return <ProgressBar />;

  return (
    <div className="container">
      <div className="content">
        {renderLogo()}
        {children}
      </div>
      {hasFooter && (
        <Footer
          country={country}
          language={language}
          privacy={strings.privacyPolicy}
          terms={strings.termsOfUse}
        />
      )}
    </div>
  );
};

export default DefaultLayout;
